import React, {useState, useEffect} from 'react'

import useConsoleStore from '../../stores/ConsoleStore';
import useTradeStore from "../../stores/TradesStore"
import useAlgoStore from '../../stores/AlgosStore';
import useTriggerStore from '../../stores/TriggersStore';

import useGridStore from '../../stores/GridStore'

import { CgProfile } from "react-icons/cg"; // Import required icons
import { FaTerminal, FaChartBar, FaBook } from "react-icons/fa"; 
import { IoMdSettings } from "react-icons/io";
import { VscDebugLineByLine } from "react-icons/vsc";
import { FcCandleSticks, FcDataConfiguration } from "react-icons/fc";
import { GiMayanPyramid } from "react-icons/gi";
import { SiBinance } from "react-icons/si";
import { MdCandlestickChart, MdCurrencyExchange } from "react-icons/md";
import { FaClipboardList } from "react-icons/fa";
import { SlTarget } from "react-icons/sl";
import { MdDonutSmall } from "react-icons/md";
import { IoWalletOutline } from "react-icons/io5";




function WidgetListContainer() {
    const { tabs, activeTabId, layouts, listItems, onLayoutChange, addToGrid, removeFromGrid } = useGridStore();
    const algoCount = useAlgoStore((state) => state.algo_count)
    const triggerCount = useTriggerStore((state) => state.trigger_count)
    const tradeCount = useTradeStore((state) => state.trade_count)
    const outputs = useConsoleStore((state) => state.outputs)

    const [stateNotifs, setStateNotifs] = useState(0)
    const [consoleNotifs, setConsoleNotifs] = useState(false)

    useEffect(() => {

      const isEmpty = (obj) => {
        return Object.keys(obj).length === 0;
      };
  
      var notif = isEmpty(outputs)
      setStateNotifs(algoCount + triggerCount + tradeCount)
      setConsoleNotifs(!notif)
    }, [algoCount, tradeCount, triggerCount, outputs, activeTabId])

    const iconMap = {
        profile: <CgProfile className='widget_list_icon'/>,
        settings: <IoMdSettings className='widget_list_icon' />,
        console: <VscDebugLineByLine className='widget_list_icon' />,
        candles: <MdCandlestickChart className='widget_list_icon' />,
        orderbook: <GiMayanPyramid className='widget_list_icon' />,
        trade: <MdCurrencyExchange className='widget_list_icon' />,
        open_orders: <FaClipboardList className='widget_list_icon' />,
        exchanges: <SiBinance className='widget_list_icon' />,
        targets: <SlTarget className='widget_list_icon' />,
        portfolio: <MdDonutSmall className='widget_list_icon'/>,
        positions: <IoWalletOutline className='widget_list_icon' />
        // Add other mappings here
      };

    const activeTab = tabs.find(tab => tab.id === activeTabId) ;

    const sortedListItems = [...activeTab.listItems].sort((a, b) =>
      a.i.localeCompare(b.i)
    );
    
  


  if (!activeTab) return null;
    return (
      <div className="widget_list_container">
      {sortedListItems.map(item => (
        <button key={item.i} onClick={() => addToGrid(item)}>
          {iconMap[item.i]} {item.i.replace(/_/g, ' ')}
          {item.i === "open_orders" ? stateNotifs && stateNotifs > 0 ? <span className='state_notif'>{stateNotifs > 99 ? "99+" : stateNotifs}</span>: null : null}
          {item.i === 'console' ? consoleNotifs ? <span className='live_dot'>"</span>: null : null}
        </button>
      ))}
    </div>
  )
}

export default WidgetListContainer